import '../components/clickable-navbar-parent-link.js';

export default {
  init() {
    // Touch Swipe Start
    jQuery(function() {
      jQuery(".swipe").swipe( {
        'allowPageScroll':"auto",

        //Generic swipe handler for all directions
        swipe:function(event, direction) {
          if (direction === 'left') {
            jQuery('.carousel-control-next').click();
          }
          if (direction === 'right') {
            jQuery('.carousel-control-prev').click();
          }
        },
      });
    });
    // Touch Swipe End

    // Init Selectpicker
    jQuery('.hide-first').each(function() {
      /*
       * Go through all selectpickers with hide-first class, find their first child (option)
       * and set data-hidden to prevent users from selecting the selectfield title as their option
       *
       * Then add a data-prop to the selectpicker, whose value is obtained from the first child.
       * This is used as selectpicker placeholder. (Taking it from first child for i18n).
       *
       */
      var placeholder = jQuery(this).children().first().val();

      jQuery(this).children().first().attr('data-hidden', true);
      jQuery(this).children().first().attr('value', '');
      jQuery(this).attr('data-none-selected-text', placeholder);
    });

    jQuery('.selectpicker').selectpicker({
      style: 'bs-dropdown',
      size: 10,
      dropupAuto : false,
    });
    // End Selectpicker

    // Smooth Scroll
    function smoothScrollInitialiser() {
      jQuery(function() {
        jQuery('a.smooth-scroll').click(function() {
          if (location.pathname.replace(/^\//,'') === this.pathname.replace(/^\//,'') && location.hostname === this.hostname) {
            var target = jQuery(this.hash);
            target = target.length ? target : jQuery('[name=' + this.hash.slice(1) +']');
            if (target.length) {
              jQuery('html,body').animate({
                scrollTop: (target.offset().top - 60),
              }, 400);
              return false;
            }
          }
        });
      });
    }
    smoothScrollInitialiser();
    // End Smooth Scroll

    // Initialise Brands Slick Slider Start
    jQuery('.slider-brands').slick({
      slidesToShow: 5,
      autoplay: true,
      autoplaySpeed: 4000,
      slidesToScroll: 1,
      swipeToSlide: true,
      dots: false,
      focusOnSelect: false,
      pauseOnFocus: false,
      infinite: true,
      prevArrow: '<button type="button" class="slick-prev"><span class="sr-only">Previous</span></button>',
      nextArrow: '<button type="button" class="slick-next"><span class="sr-only">Next</span></button>',
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            centerMode: true,
          },
        },
      ],
    });
    // Initialise Brands Slick Slider End

    // Normalize Carousel Start
    $.fn.carouselHeights = function() {

      var items = $(this), //grab all slides
          heights = [], //create empty array to store height values
          tallest; //create variable to make note of the tallest slide

      var normalizeHeights = function() {
        items.each(function() { //add heights to array
          heights.push($(this).height()); 
        });
        tallest = Math.max.apply(null, heights); //cache largest value
        items.each(function() {
          $(this).css('min-height',tallest + 'px');
        });
      };

      normalizeHeights();

      $(window).on('resize orientationchange', function () {
        //reset vars
        tallest = 0;
        heights.length = 0;

        items.each(function() {
          $(this).css('min-height','0'); //reset min-height
        }); 
        normalizeHeights(); //run it again 
      });
    };

    jQuery(function($){
      $(window).on('load', function(){
        $('.carousel .carousel-item').carouselHeights();
      });
    });
    // Normalize Carousel End

    // Initialise Masonry Start
    var $grid = $('.grid').imagesLoaded( function() {
    // init Packery after all images have loaded
      $grid.packery({
        itemSelector: '.grid-item',
        percentPosition: true,
        gutter: 0,
      });
      jQuery('.grid').addClass('loaded');
    });
    // Initialise Masonry End
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js